module.exports = __webpack_public_path__ + "static/logo-se-393a20f0b88327b4772a5cb4169e5213.png";